import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { DeleteReason } from '@app/models/delete-reason'
import { IDeleteVetRequest } from '@app/models/delete-vet-request'
import { IPetDetails } from '@app/models/pet-details'

import { IAddVetRequest } from '@models/add-vet-request'
import { IVetResponse } from '@models/add-vet-response'
import { IVetClinic } from '@models/vet-clinic'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'


@Injectable({
	providedIn: 'root',
})
export class OrchestratorService {
	// possibly move this to a higher scope
	private readonly apiVersion: string = 'v1'
	private readonly vetSearchRadius: number = 30

	constructor (private readonly http: HttpClient) { }

	/**
	 * Searches vets within a raidus of the given zip code
	 *
	 * @param zipCode The zip code to search for vets near
	 * @param radius The radius, in miles, from the zip that vets should be searched in. **Default: 30**
	 */
	public getVetsGivenZip (zipCode: string, radius = this.vetSearchRadius): Observable<IVetClinic[]> {
		return this.http
			.get<IVetClinic[]>(`${environment.endpoint}/${this.apiVersion}/VetClinic?zipCode=${zipCode}&radius=${radius}`)
	}

	/**
	 * Will add the selected vet to the pet
	 *
	 * @param petId The GUID of the pet to add thet vet to
	 * @param payload The vet data to add to the pet
	 */
	public addVet (petId: string, payload: IAddVetRequest): Observable<IVetResponse> {
		return this.http.post<IVetResponse>(
			`${environment.endpoint}/${this.apiVersion}/PetDetails/${petId}/Vet`,
			payload,
		)
	}

	/**
	 * Updates 'other names' and 'other owners' for the specified pet
	 *
	 * @param petId The GUID of the pet that should be updated
	 * @param payload The vet data to update on the pet
	 */
	public editVet (petId: string, payload: Pick<IAddVetRequest, 'otherNames'|'otherOwners'|'vetId'>): Observable<IVetResponse> {
		const { vetId, otherNames, otherOwners } = payload

		return this.http.put<IVetResponse>(
			`${environment.endpoint}/${this.apiVersion}/PetDetails/${petId}/Vet/${vetId}`,
			{
				otherNames,
				otherOwners,
			},
		)
	}

	/** * Removes a Vet Clinic from the specified pet */
	public deleteVet ({ petId, vetId, reason = DeleteReason.Other }: IDeleteVetRequest): Observable<IVetResponse> {
		return this.http
			.delete<IVetResponse>(`${environment.endpoint}/${this.apiVersion}/PetDetails/${petId}/Vet/${vetId}?reason=${reason}`)
	}

	/**
	 * Gets the pet details object with providers to display
	 *
	 * @param petId The GUID for the pet
	 */
	public getPetDetails (petId: string): Observable<IPetDetails> {
		return this.http
			.get<IPetDetails>(`${environment.endpoint}/${this.apiVersion}/PetDetails?id=${petId}`)
	}
}
